<div class="p-3 rounded-3">
    <div class="row mb-2">
        <div class="col-12 mb-3">
            <div class="titletoptables">
                <div class="leftsideicons">
                    <img src="../../assets/image/multiple-users.png" alt="multiuser" />
                </div>
                <h3>
                    {{ "Client Directory" }}
                </h3>
            </div>
        </div>
        <div class="row position">
            <div class="col-md-12 kt-margin-bottom-20-mobile" style="display:flex;">
                <div class="col-md-2">
                    <div class="srchgrid texttarget">
                        <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)"
                            [value]="searchString" placeholder="Search" autocomplete="off">
                        <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
                                aria-hidden="true">&times;</span> </div>
                    </div>
                </div>
                <div class="col-md-10 toogle">
                    <div class="btn-group-offer">
                        <button type="button" class="btn btn-primary addBtn"
                            (click)="openClientDirectoryDialog(null)">Add
                            Client Directory</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="position">
        <kendo-grid #grid [loading]='kendoLoading' [data]=" gridData" [filter]="state.filter"
            [sortable]="{mode: 'single'}" [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
            [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false"
            (pageChange)="pageChange($event)" [sort]="sort"
            (sortChange)="clientDirectoryData ? sortChange($event): null" [resizable]="true" [reorderable]="true"
            filterable="menu" [filter]="state.filter" [selectable]="true"
            (columnVisibilityChange)="onColumnVisibilityChange(grid)"
            (dataStateChange)="clientDirectoryData ? dataStateChange($event): null" [navigable]="true"
            [height]="gridHeight" (dblclick)="onRowDoubleClick($event)">
            <kendo-grid-column field="Name" [width]="100" title="Name">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.Salutation ?? ''}} {{dataItem.Name}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClinicName" [width]="100" title="Clinic Name">
            </kendo-grid-column>
            <kendo-grid-column field="Email" [width]="100" title="Email">
            </kendo-grid-column>
            <kendo-grid-column field="MobileNumber" [width]="100" title="Mobile Number">
            </kendo-grid-column>
            <kendo-grid-column field="City" [width]="100" title="City">
            </kendo-grid-column>
            <kendo-grid-column field="State" [width]="100" title="State">
            </kendo-grid-column>
            <kendo-grid-column field="Address" [width]="100" title="Address">
            </kendo-grid-column>
            <kendo-grid-column field="Education" [width]="100" title="Education">
            </kendo-grid-column>
            <kendo-grid-column field="ExperienceValue" [width]="100" title="Experience">
            </kendo-grid-column>
            <kendo-grid-column field="ConsultationFees" [width]="100" title="Consultation Fees">
            </kendo-grid-column>
            <kendo-grid-column [width]="100" title="Clinic Time">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.ClinicTimeDisplay"></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="100" title="Services">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.ServiceDisplay"></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="100" title="Specialization">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.SpecializationDisplay"></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Memberships" [width]="100" title="Memberships">
            </kendo-grid-column>
            <kendo-grid-column field="Action" [width]="100" title="Action">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div class="d-flex">
                        <mat-slide-toggle [(ngModel)]="dataItem.IsDoctorDirectoryEnable"
                            (change)="onToggleStatus(dataItem)">
                        </mat-slide-toggle>
                        <div class="mx-2">
                            <button class="verical_menu" type="button" id="dropdownMenuButton1"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <img src="/assets/image/vertical-icon.png" alt="" class="vertical">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li style="cursor: pointer;">
                                    <a class="dropdown-item" (keydown.enter)="openClientDirectoryDialog(dataItem)"
                                        (click)="openClientDirectoryDialog(dataItem)" data-bs-toggle="modal"
                                        data-bs-target="#exampleModal">Edit</a>
                                </li>
                                <li style="cursor:pointer ;"><a class="dropdown-item" *ngIf="!dataItem.IsClientDomain"
                                        (keydown.enter)="openDomainConvertDialog(dataItem)"
                                        (click)="openDomainConvertDialog(dataItem)">Create Domain</a></li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>
<ng-template #clientDirectoryDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header"
                style="margin-bottom:5px; display: flex; align-items: center; justify-content: space-between;">
                <h4 class="popup-title">{{action}} Client Directory</h4>
                <div class="header-actions" style="display: flex; gap: 8px;">
                    <button mat-icon-button (click)="toggleMaximize()">
                        <mat-icon style="margin-top:-22px;">{{ isMaximized ? 'fullscreen_exit' : 'fullscreen'
                            }}</mat-icon>
                    </button>
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
                </div>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <form [formGroup]="addClientDirectoryFrom">
                        <div class="row">
                            <div class="col-4 col-md-1 col-lg-1 kt-margin-bottom-20-mobile py-2">
                                <div class="form-group">
                                    <mat-form-field class="example-full-width custom-blue">
                                        <mat-label>Salutation</mat-label>
                                        <mat-select formControlName="Salutation" [panelClass]="'custom-select-panel'"
                                            [disableOptionCentering]="true">
                                            <mat-option value="Dr.">Dr.</mat-option>
                                            <mat-option value="Mr.">Mr.</mat-option>
                                            <mat-option value="Mrs.">Mrs.</mat-option>
                                            <mat-option value="Ms.">Ms.</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-4 col-md-3 col-lg-3 kt-margin-bottom-20-mobile py-2">
                                <div class="form-group">
                                    <mat-form-field class="example-full-width custom-blue">
                                        <mat-label>Name</mat-label>
                                        <input matInput type="text" formControlName="Name" maxlength="100" required />
                                        <mat-error
                                            *ngIf="addClientDirectoryFrom.get('Name')?.errors?.['required'] || addClientDirectoryFrom.get('Name')?.errors?.['whitespace']">
                                            Name is required
                                        </mat-error>
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Name')?.errors?.['maxlength']">
                                            Max 100 characters allowed
                                        </mat-error>
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Name')?.errors?.['invalidName']">
                                            Name can only contain letters, spaces, dot (.), hyphen (-) and
                                            apostrophe(').
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-4 col-md-4 col-lg-4 kt-margin-bottom-20-mobile py-2">
                                <div class="form-group">
                                    <mat-form-field class="example-full-width custom-blue">
                                        <mat-label>Clinic Name</mat-label>
                                        <input matInput type="text" formControlName="ClinicName" maxlength="250"
                                            required />
                                        <mat-error
                                            *ngIf="addClientDirectoryFrom.get('ClinicName')?.errors?.['required'] || addClientDirectoryFrom.get('ClinicName')?.errors?.['whitespace']">
                                            Clinic Name is required
                                        </mat-error>
                                        <mat-error
                                            *ngIf="addClientDirectoryFrom.get('ClinicName')?.errors?.['maxlength']">Max
                                            50 characters allowed</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-4 col-md-4 col-lg-4 kt-margin-bottom-20-mobile py-2">
                                <div class="form-group">
                                    <mat-form-field class="example-full-width custom-blue">
                                        <mat-label>Email</mat-label>
                                        <input matInput type="text" formControlName="Email"
                                            (keyup)="handleBlurEmail($event)" required />
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Email')?.errors?.['required']">
                                            Email is required</mat-error>
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Email')?.errors?.['pattern']">
                                            Invalid email format</mat-error>
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Email')?.errors?.['emailExists']">
                                            Email already exists, please use a different Email
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <mat-form-field class="example-full-width custom-blue">
                                    <mat-label>Mobile Number</mat-label>
                                    <input matInput type="text" formControlName="MobileNumber"
                                        (keypress)="keyPress($event)" maxlength="15" required />
                                    <mat-error *ngIf="addClientDirectoryFrom.get('MobileNumber')?.errors?.['required']">
                                        Mobile Number is required
                                    </mat-error>
                                    <mat-error *ngIf="addClientDirectoryFrom.get('MobileNumber')?.errors?.['pattern']">
                                        Only digits are allowed
                                    </mat-error>
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('MobileNumber')?.errors?.['minlength']">
                                        Mobile number must be at least 10 digits.
                                    </mat-error>
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('MobileNumber')?.errors?.['maxlength']">
                                        Mobile number cannot exceed 15 digits.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 py-2">
                                <mat-form-field class="example-full-width custom-blue">
                                    <mat-label>Address</mat-label>
                                    <input matInput type="text" formControlName="Address" #search
                                        placeholder="Enter Address" required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('Address')?.errors?.['required'] || addClientDirectoryFrom.get('Address')?.errors?.['whitespace']">
                                        Address is required
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 py-2">
                                <mat-form-field class="example-full-width custom-blue">
                                    <mat-label>State</mat-label>
                                    <input matInput type="text" formControlName="State" placeholder="Enter State"
                                        required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('State')?.errors?.['required'] || addClientDirectoryFrom.get('State')?.errors?.['whitespace']">
                                        State is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Row 3 -->
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <mat-form-field class="example-full-width custom-blue">
                                    <mat-label>Education</mat-label>
                                    <input matInput type="text" formControlName="Education" required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('Education')?.errors?.['required'] || addClientDirectoryFrom.get('Education')?.errors?.['whitespace']">
                                        Education is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 py-2">
                                <mat-form-field class="example-full-width custom-blue">
                                    <mat-label>Consultation Fees</mat-label>
                                    <input matInput type="number" formControlName="ConsultationFees" min="0" required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('ConsultationFees')?.errors?.['required'] || addClientDirectoryFrom.get('ConsultationFees')?.errors?.['whitespace']">
                                        Consultation Fees is required
                                    </mat-error>
                                    <mat-error *ngIf="addClientDirectoryFrom.get('ConsultationFees')?.errors?.['min']">
                                        Consultation Fees must be a positive number.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 py-2">
                                <div class="row">
                                    <div class="col-md-9">
                                        <div class="form-group position-relative w-100 custom-mat-style"
                                            #wrapper_special>
                                            <label class="floating-label" [class.active]="labelActive_specialization"
                                                for="specializationDropdown">
                                                Specialization
                                            </label>

                                            <button id="specializationDropdown" type="button"
                                                class="form-control text-start d-flex justify-content-between align-items-center dropdown-toggle"
                                                (click)="toggleDropdown_special($event)"
                                                (focusin)="onButtonFocus_special()" (focusout)="onButtonBlur_special()">
                                                <span class="selected-text">
                                                    {{
                                                    selectedSpecializationNames?.length
                                                    ? selectedSpecializationNames : '' }}
                                                </span>
                                                <span style="margin-top:10px"><i class="bi bi-chevron-down ms-2"></i></span>
                                            </button>
                                            <mat-error style="margin-top: 3px;font-size: 10.30px;"
                                                *ngIf="addClientDirectoryFrom.get('SpecializationIds')?.touched && addClientDirectoryFrom.get('SpecializationIds')?.invalid">
                                                Specialization is required
                                            </mat-error>
                                            <ul class="dropdown-menu w-100 p-2 services-scroll"
                                                [class.show]="isDropdownOpen_specialization">
                                                <li class="mb-2">
                                                    <input type="text" class="form-control form-control-sm"
                                                        placeholder="Search..."
                                                        (keyup)="filterSpecializations($event)" />
                                                </li>

                                                <li *ngFor="let special of filteredSpecializationList">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            [id]="'special_' + special.Id" [value]="special.Id"
                                                            (change)="toggleSpecialization(special, $event)"
                                                            [checked]="isSelectedSpecialization(special)" />
                                                        <label class="form-check-label" [for]="'special_' + special.Id">
                                                            {{ special.Name }}
                                                        </label>
                                                    </div>
                                                </li>

                                                <li *ngIf="filteredSpecializationList.length === 0"
                                                    class="text-center text-muted">
                                                    No data found
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-0">
                                        <button type="button" class="btn btn-primary w-100"
                                            (click)="openDialogForAddSpecialization(AddSpecialization)">
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Row 4 -->
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <mat-form-field class="example-full-width custom-blue">
                                    <mat-label>Experience</mat-label>
                                    <input matInput type="number" formControlName="Experience" min="0" required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('Experience')?.errors?.['required'] || addClientDirectoryFrom.get('Experience')?.errors?.['whitespace']">
                                        Experience is required
                                    </mat-error>
                                    <mat-error *ngIf="addClientDirectoryFrom.get('Experience')?.errors?.['min']">
                                        Experience must be a positive number.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 py-2">
                                <mat-form-field class="example-full-width custom-blue">
                                    <mat-label>Memberships</mat-label>
                                    <input matInput type="text" formControlName="Memberships" />
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 py-2">
                                <div class="row">
                                    <div class="col-md-9">
                                        <div class="form-group position-relative w-100 custom-mat-style"
                                            #wrapper_service>
                                            <label class="floating-label" [class.active]="labelActive_service"
                                                for="servicesDropdown">
                                                Services
                                            </label>

                                            <button id="servicesDropdown" type="button" 
                                                class="form-control text-start d-flex justify-content-between align-items-center dropdown-toggle"
                                                (click)="toggleDropdown_service($event)"
                                                (focusin)="onButtonFocus_service()" (focusout)="onButtonBlur_service()">
                                                <span class="selected-text">
                                                    {{
                                                    selectedServicesNames?.length
                                                    ? selectedServicesNames : '' }}
                                                </span>
                                            </button>
                                            <mat-error style="margin-top: 3px;font-size: 10.30px;"
                                                *ngIf="addClientDirectoryFrom.get('ServicesIds')?.touched && addClientDirectoryFrom.get('ServicesIds')?.invalid">
                                                Service is required
                                            </mat-error>
                                            <ul class="dropdown-menu w-100 p-2 services-scroll"
                                                [class.show]="isDropdownOpen_service">
                                                <li class="mb-2">
                                                    <input type="text" class="form-control form-control-sm"
                                                        placeholder="Search..." (keyup)="filterServices($event)" />
                                                </li>
                                                <li *ngFor="let service of filteredServicesList">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            [id]="'service_' + service.Id" [value]="service.Id"
                                                            (change)="toggleService(service, $event)"
                                                            [checked]="isSelected(service)" />
                                                        <label class="form-check-label" [for]="'service_' + service.Id">
                                                            {{ service.Name }}
                                                        </label>
                                                    </div>
                                                </li>
                                                <li *ngIf="filteredServicesList.length === 0"
                                                    class="text-center text-muted">
                                                    No data found
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-0">
                                        <button type="button" class="btn btn-primary w-100"
                                            (click)="openDialogForAddService(AddServices)">
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Row 5 -->
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <mat-form-field class="example-full-width custom-blue">
                                    <mat-label>Description</mat-label>
                                    <textarea matInput formControlName="Description" rows="2"></textarea>
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 py-2">
                                <label class="mb-2" for="gender-radio-group">Gender</label><br />
                                <mat-radio-group id="gender-radio-group" formControlName="Gender" class="pt-2">
                                    <mat-radio-button value="Male" class="mr-3">Male</mat-radio-button>
                                    <mat-radio-button value="Female">Female</mat-radio-button>
                                </mat-radio-group>
                            </div>

                            <div class="col-md-4 py-2">
                                <div class="row">
                                    <div class="col-md-8 pt-3">
                                        <label class="mb-2" for="ClinicTiming">Days & Timing</label><br />
                                    </div>
                                    <div class="col-md-4 px-0 pt-3">
                                        <button type="button" class="btn btn-primary px-2 w-100"
                                            (click)="openDialogForAddTiming(AddClinicTiming)">
                                            Add Timing
                                        </button>
                                    </div>
                                    <div class="col-md-12" *ngIf="doctorTimings && doctorTimings.length > 0">
                                        <div *ngFor="let timing of doctorTimings; let i = index">
                                            <span class="d-block" *ngIf="timing.FromTime && timing.ToTime">
                                                {{ timing.FromDay }} - {{ timing.ToDay }}
                                                : {{ timing.FromTime | date : "HH:mm" }} - {{ timing.ToTime | date :
                                                "HH:mm" }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Row 6 -->
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <mat-label>Profile Photo</mat-label><br />
                                <input #Myfile type="file" (change)="onFileChange($event)"
                                    class="btn btn-secondary btn-elevate kt-login__btn-primary p-2" />
                                <p class="mb-0">{{ profileName }}</p>
                            </div>

                            <div class="col-md-4 py-2" *ngIf="profileUrl">
                                <div class="form-group ms-2 picture-container">
                                    <img [src]="profileUrl"
                                        class="img-fluid rounded shadow profile-client-img picture-img" alt="Profile" />
                                    <button *ngIf="profileUrl" class="remove-picture-btn" (click)="removeImage()">
                                        X
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </mat-dialog-content>
                <mat-dialog-actions align="end">
                    <button mat-raised-button (click)="closeDialog()" style="margin-right: 10px;" type="button"
                        class="btn btn-secondary" tabindex="-1">Cancel</button>
                    <button mat-raised-button type="button" class="btn btn-primary"
                        (click)="submitClientDirectory()">{{this.action}}</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #AddServices>
    <div class="purpose">
        <div class="purpose-popup">
            <div>
                <h4 class="popup-title">Add Services</h4>
                <div class="crossIcon"><i mat-dialog-close class="fa fa-times"></i> </div>
            </div>
            <form class="diagSave" style="margin-top: 15px;" [formGroup]="servicesForm"
                (ngSubmit)="addServices(servicesForm)" autocomplete="off">
                <div class="mat-dialog-content-purpose">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <mat-form-field class="saveInput">
                                    <mat-label>Name</mat-label>
                                    <input type="text" matInput formControlName="Name" required />
                                    <mat-error
                                        *ngIf="(servicesForm.controls['Name'].hasError('required') &&
                                        servicesForm.controls['Name'].touched) || servicesForm.controls['Name'].untouched">required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-secondary"
                        (click)="closeServiceDialog()">Cancel</button>
                    <button mat-raised-button type="button" class="btn btn-primary" (click)="addServices(servicesForm)">
                        Save</button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>
<ng-template #AddSpecialization>
    <div class="purpose">
        <div class="purpose-popup">
            <div>
                <h4 class="popup-title">
                    Add Specialization
                </h4>
                <div class="crossIcon"><i mat-dialog-close class="fa fa-times"></i> </div>
            </div>
            <form class="diagSave" style="margin-top: 15px;" [formGroup]="specializationForm"
                (ngSubmit)="addSpecialization(specializationForm)" autocomplete="off">
                <div class="mat-dialog-content-purpose">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <mat-form-field class="saveInput">
                                    <mat-label>Name</mat-label>
                                    <input type="text" matInput formControlName="Name" required />
                                    <mat-error
                                        *ngIf="
                                            (specializationForm.controls['Name'].hasError('required') &&
                                                specializationForm.controls['Name'].touched) || specializationForm.controls['Name'].untouched">
                                        required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-secondary"
                        (click)="closeSpecializationDialog()">Cancel</button>
                    <button mat-raised-button type="button" class="btn btn-primary"
                        (click)="addSpecialization(specializationForm)">
                        Save</button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>
<ng-template #AddClinicTiming>
    <div class="purpose">
        <div class="purpose-popup">
            <div class="d-flex justify-content-between">
                <h4 class="popup-title">
                    Add Timing
                </h4>
                <button mat-raised-button type="button" class="btn btn-primary"
                    (click)="onAddClick(timingArray.length - 1)">
                    + Add
                </button>
            </div>
            <form class="diagSave" style="margin-top: 15px;" *ngIf="timingForm" [formGroup]="timingForm"
                autocomplete="off">
                <div class="mat-dialog-content-purpose">
                    <div formArrayName="ClinicTimings">
                        <div *ngFor="let timing of timingArray.controls; let i = index; let last = last"
                            [formGroupName]="i" class="form-group row">
                            <div class="col-md-2">
                                <label class="mb-2 font-weight-bold" for="fromDay">From Day</label>
                                <select class="form-control" id="fromDay" formControlName="fromDay">
                                    <option value="" disabled>Select from day</option>
                                    <option *ngFor="let day of weekDays" [value]="day">
                                        {{ day }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <label class="mb-2 font-weight-bold" for="toDay">To Day</label>
                                <select class="form-control" id="toDay" formControlName="toDay">
                                    <option value="" disabled>Select to day</option>
                                    <option *ngFor="let day of weekDays" [value]="day">
                                        {{ day }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label class="mb-2 font-weight-bold" for="fromTime">Start Time</label>
                                <kendo-timepicker formControlName="fromTime" [format]="'HH:mm'" class="mt-1"
                                    (valueChange)="onTimeChange(i)">
                                </kendo-timepicker>
                            </div>
                            <div class="col-md-3">
                                <label class="mb-2 font-weight-bold" for="toTime">Close Time</label>
                                <kendo-timepicker formControlName="toTime" [format]="'HH:mm'" class="mt-1"
                                    (valueChange)="onTimeChange(i)">
                                </kendo-timepicker>
                            </div>
                            <div class="col-md-2 d-flex flex-column justify-content-end align-items-center mb-2">
                                <button type="button" class="btn-close" aria-label="Close"
                                    (click)="removeTimingRow(i)"></button>
                            </div>
                            <div class="col-4">
                            </div>
                            <div class="col-8">
                                <div *ngIf="timing.errors?.['invalidTime']" class="invalid-feedback d-block">
                                    start time must be less than close time
                                </div>
                            </div>
                            <div class="col-12">
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-secondary"
                        (click)=" cancelTimingDialog()">Cancel</button>
                    <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-primary"
                        (click)="saveTimingDialog()">Okay</button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>
<ng-template #updateStatusDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header" style="margin-bottom:5px">
                <h4 class="popup-title">Update Status Confirmation</h4>
                <button type="button" class="btn-close" aria-label="Close" mat-dialog-close
                    (click)="Noupdate()"></button>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <div>Are you sure you want to update status?</div>
                </mat-dialog-content>
                <mat-dialog-actions align="end" style="gap:20px;">
                    <button mat-raised-button style="margin-left: 20px;" type="button" class="btn btn-secondary"
                        tabindex="-1" (click)="Noupdate()" mat-dialog-close>No</button>
                    <button mat-raised-button type="button" (click)="updateStatus()" class="btn btn-primary"
                        tabindex="0">Yes</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #domainConvertDialog>
    <div class="d-flex justify-content-between">
        <h4 class="dialog-title">Create Domain</h4>
        <div class="dialog-controls">
            <button type="button" class="btn-close" aria-label="Close" mat-dialog-close></button>
        </div>
    </div>
    <div class="pt-3">
        <form class="kt-form" [formGroup]="domainForm" autocomplete="off">
            <div class="row">
                <div class="col-4 col-md-2 col-lg-2 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-label>Salutation</mat-label>
                            <mat-select formControlName="Salutation" [panelClass]="'custom-select-panel'"
                                [disableOptionCentering]="true">
                                <mat-option value="Dr.">Dr.</mat-option>
                                <mat-option value="Mr.">Mr.</mat-option>
                                <mat-option value="Mrs.">Mrs.</mat-option>
                                <mat-option value="Ms.">Ms.</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-8 col-md-4 col-lg-4 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-label>Doctor Name</mat-label>
                            <input matInput type="text" formControlName="FirstName" autocomplete="off" maxlength="100"
                                required />
                            <mat-error *ngIf="isControlHasError('FirstName', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('FirstName')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('FirstName', 'maxlength')">
                                This field is required only 100 characters
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('FirstName', 'invalidName')">
                                Name can only contain letters, spaces, dot (.), hyphen (-) and apostrophe
                                (').</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-label>Clinic Name</mat-label>
                            <input matInput pattern="^[A-Za-z\s][A-Za-z0-9\s]*$" type="text"
                                formControlName="CompanyName" autocomplete="off" maxlength="250"
                                (keyup)="handleBlurName()" required />
                            <mat-error *ngIf="isControlHasError('CompanyName', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('CompanyName')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('CompanyName', 'pattern')">
                                Can not start with Numeric and cannot add Speacial
                                    characters
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('CompanyName', 'maxlength')">
                                This field is required only 250 characters
                            </mat-error>
                        </mat-form-field>
                        <mat-error *ngIf="error">
                            Clinic name already exist, please use different clinic
                                name or if you forgot your clinic name then please use
                                forgot password.
                        </mat-error>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue" style="width: 70%">
                            <mat-label>Clinic Domain Name</mat-label>
                            <input matInput pattern="^[A-Za-z\s][A-Za-z0-9\s]*$" type="text"
                                formControlName="CompanyCode" autocomplete="off" maxlength="100"
                                (keyup)="handleBlurCompanyCode()" required/>
                            <mat-error *ngIf="isControlHasError('CompanyCode', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('CompanyCode')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('CompanyCode', 'pattern')">
                                Can not start with Numeric and cannot add Speacial
                                    characters
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('CompanyCode', 'maxlength')">
                                This field is required only 100 characters
                            </mat-error>
                        </mat-form-field>
                        <span style="font-weight: 600">{{ domainName }}</span>
                        <mat-error *ngIf="companycodeerror">
                            Domain name already exist, please use different domain
                                name.
                        </mat-error>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-label>Email</mat-label>
                            <input matInput type="text" formControlName="Email" autocomplete="off" maxlength="50"
                                (keyup)="handleBlurEmailbyId($event,selectedDoctor.Id)" required />

                            <mat-error *ngIf="isControlHasError('Email', 'required')">
                                This field is required
                            </mat-error>

                            <mat-error *ngIf="isControlHasError('Email', 'pattern')">
                                follow standard email pattern
                            </mat-error>
                            <mat-error *ngIf="emailerror">
                                Email already exist, please use different Email.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-label>Password</mat-label>
                            <input matInput [type]="hide ? 'password' : 'text'" formControlName="Password" required>
                            <mat-icon matSuffix (click)="hide = !hide" (keydown.enter)="hide = !hide">{{hide ?
                                'visibility_off' : 'visibility'}}
                            </mat-icon>
                            <mat-error *ngIf="isControlHasError('Password', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('Password')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('Password', 'minlength')">
                                Password must be at least 6 characters
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-label>Phone Number</mat-label>
                            <input matInput type="text" (keypress)="keyPress($event)"
                                (ngModelChange)="onPhoneNumberKeyup()" formControlName="PhoneNumber" autocomplete="off"
                                required />
                            <mat-error *ngIf="isControlHasError('PhoneNumber', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf=" domainForm.get('PhoneNumber')?.hasError('invalidPhone')">
                                Invalid phone number
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('PhoneNumber')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-label>Country</mat-label>
                            <mat-select formControlName="CurrencyId" [panelClass]="'custom-select-panel'"
                                [disableOptionCentering]="true">
                                <mat-option *ngFor="let item of currencyList" [value]="item.Id">{{
                                    item.CountryName
                                    }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="isControlHasError('CurrencyId', 'required')">
                                This field is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <mat-form-field class="example-full-width custom-blue w-100">
                            <mat-label>Clinic Address</mat-label>
                            <input matInput formControlName="CompanyAddress" placeholder="Search for location"
                                autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
                                class="form-control address-search" #searchAdd required />
                            <mat-error *ngIf="isControlHasError('CompanyAddress', 'required')">
                                This field is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

            </div>
            <mat-dialog-actions align="end">
                <button style="display: flex;gap: 20px;" (click)="convertDomain()" id="kt_login_signin_submit"
                    [class.spinner]="loading" class="btn btn-primary btn-elevate kt-login__btn-primary ml-2"
                    [disabled]=" !domainForm.valid || error || emailerror || companycodeerror || isInProgress || loading">
                    Submit
                </button>
            </mat-dialog-actions>
        </form>
    </div>
</ng-template>